import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { useSegmentTracking } from '../hooks/use-segment-tracking';
import { COACHMARK_CLOSE, COACHMARK_LEARN_MORE } from '../../../constants/analytics-events';
import { HelpCenterService } from '../../../services/helpcenter-service';

import styles from './custom-tooltip.module.less';

const messages = defineMessages({
  learnMoreButton: {
    defaultMessage: 'Learn More',
    id: 'dnXbRJ',
    description: 'Learn More link text',
  },
  gotItButton: {
    defaultMessage: 'Got It',
    id: 'p3YMrL',
    description: 'Got it link text',
  },
});

export const CoachmarkTooltip = ({ step, primaryProps, closeProps, tooltipProps }) => {
  const segmentTrackingLearnMore = useSegmentTracking(COACHMARK_LEARN_MORE);
  const segmentCloseUsingX = useSegmentTracking(COACHMARK_CLOSE, {
    type: 'hit X',
  });
  const onClickCloseTooltipX = useCallback(
    (e) => {
      segmentCloseUsingX();
      closeProps.onClick(e);
    },
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    [closeProps.onClick, segmentCloseUsingX],
  );
  return (
    <div className={styles.wrapper} {...tooltipProps}>
      <div className={styles.title}>
        {step.title}
        <div {...closeProps} onClick={onClickCloseTooltipX}>
          <FontAwesomeIcon className={styles['close-icon']} icon={faXmark} />
        </div>
      </div>
      <div className={styles.body}>{step.content}</div>
      <div className={styles.footer}>
        {step.learnMoreLink && (
          <Button
            className={styles['help-button']}
            href={`${HelpCenterService.getHelpCenterUrl()}/${step.learnMoreLink}`}
            onClick={segmentTrackingLearnMore}
            theme='link'
          >
            <FormattedMessage {...messages.learnMoreButton} />
          </Button>
        )}
        <Button className={styles['primary-button']} theme='primary' {...primaryProps}>
          <FormattedMessage {...messages.gotItButton} />
        </Button>
      </div>
    </div>
  );
};

CoachmarkTooltip.propTypes = {
  step: PropTypes.object.isRequired,
  primaryProps: PropTypes.object.isRequired,
  tooltipProps: PropTypes.object.isRequired,
  closeProps: PropTypes.object.isRequired,
};
